import { render } from "./DashboardCard.vue?vue&type=template&id=771859f8&ts=true"
import script from "./DashboardCard.vue?vue&type=script&lang=ts"
export * from "./DashboardCard.vue?vue&type=script&lang=ts"

import "./DashboardCard.vue?vue&type=style&index=0&id=771859f8&lang=scss"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__